import React from 'react';
import { motion } from 'framer-motion';
import publicData from '../../../data/publicData.json';

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};

const WhatWeDoSection = ({ theme = 'light' }) => {
  const { title, services } = publicData.about.whatWeDo;

  return (
    <section className={`py-20 ${theme === 'dark' ? 'bg-white text-gray-900' : 'bg-gray-50 text-gray-900'}`}>
      <motion.div
        className="container mx-auto px-4 max-w-5xl"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: '-100px' }}
        variants={containerVariants}
      >
        <motion.h2 className="text-4xl md:text-5xl font-bold mb-12 text-center" variants={itemVariants}>
          {title}
        </motion.h2>
        <motion.div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" variants={containerVariants}>
          {services.map((service, idx) => (
            <motion.div
              key={idx}
              className={`p-6 rounded-lg flex flex-col items-center text-center ${theme === 'dark' ? 'bg-gray-100' : 'bg-white'} hover:shadow-xl transition-all duration-300`}
              variants={itemVariants}
              whileHover={{ scale: 1.05, transition: { duration: 0.3 } }}
              whileTap={{ scale: 0.95 }}
            >
              <div className="text-4xl mb-4">{service.icon}</div>
              <h3 className="text-xl font-semibold mb-2">{service.title}</h3>
              <p className="text-gray-600 dark:text-gray-700">{service.description}</p>
            </motion.div>
          ))}
        </motion.div>
      </motion.div>
    </section>
  );
};

export default WhatWeDoSection; 